import ButtonCinestar from '../../../Buttons/ButtonCinestar/ButtonCinestar'

import './BottomProgramMenu.scss'

const BottomProgramMenu = ({ openedMenu, programHandleClick, menuHandleClick }) => {
    return (
        <div className={'bottom-program-menu fixed-bottom d-flex text-formPrimary rounded-1 m-2'}>
            <div className={'w-50'} onClick={programHandleClick}>
                <ButtonCinestar variant={'secondary'} iconLeft={'program'} className={'border-0 mx-auto'}>
                    Program
                </ButtonCinestar>
            </div>

            <div
                className={`border border-start border-end border-formPrimary border-opacity-25 my-2 ${
                    openedMenu ? 'opacity-0' : ''
                }`}
            />

            <div className={`${openedMenu && 'bg-white'} rounded-end w-50`} onClick={menuHandleClick}>
                <ButtonCinestar
                    variant={'secondary'}
                    iconLeft={openedMenu ? 'menu-active' : 'menu'}
                    className={`${openedMenu && 'bottom-program-menu--active'} border-0 mx-auto`}
                >
                    Menu
                </ButtonCinestar>
            </div>
        </div>
    )
}

export default BottomProgramMenu
